module.exports = __webpack_public_path__ + "img/portrait-ron.ad65c402.jpg";